import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'PushAdvertisementEdit',
  data: function data() {
    return {
      citys: [],
      props: {
        multiple: true
      },
      marriages: [],
      educations: [],
      minAges: [],
      maxAges: [],
      sex: [],
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      fileList: [],
      pushMessagePeopleGrous: [],
      pushMessagePushTypeEnums: [],
      title: '',
      form: {
        advId: null,
        message: '',
        images: '',
        peopleGroup: '',
        pushType: '',
        browseNum: null,
        commentNum: null,
        fabulousNum: null,
        operatorUserId: null,
        pushTime: null,
        messageType: null,
        messageUserId: null,
        sex: null,
        advCity: []
      },
      rules: {
        advId: [{
          required: true,
          message: '请输入消息id',
          trigger: 'blur'
        }],
        message: [{
          required: true,
          message: '请输入消息',
          trigger: 'blur'
        }],
        images: [{
          required: true,
          message: '请输入图片',
          trigger: 'blur'
        }],
        peopleGroup: [{
          required: true,
          message: '请输入推送群体',
          trigger: 'blur'
        }],
        pushType: [{
          required: true,
          message: '请输入推送类型',
          trigger: 'blur'
        }],
        browseNum: [{
          required: true,
          message: '请输入浏览数',
          trigger: 'blur'
        }],
        commentNum: [{
          required: true,
          message: '请输入评论数',
          trigger: 'blur'
        }],
        fabulousNum: [{
          required: true,
          message: '请输入点赞',
          trigger: 'blur'
        }],
        operatorUserId: [{
          required: true,
          message: '请输入操作人ID',
          trigger: 'blur'
        }],
        pushTime: [{
          required: true,
          message: '请输入推送时间',
          trigger: 'blur'
        }],
        messageType: [{
          required: true,
          message: '请输入消息类型;0 推送消息 1新用户消息 2生日消息',
          trigger: 'blur'
        }],
        messageUserId: [{
          required: true,
          message: '请输入推送人ID',
          trigger: 'blur'
        }],
        url: [{
          required: true,
          message: '请输入url',
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: '性别不能为空',
          trigger: 'blur'
        }],
        maxAge: [{
          required: true,
          message: '最大年龄不能为空',
          trigger: 'blur'
        }],
        minAge: [{
          required: true,
          message: '最小年龄不能为空',
          trigger: 'blur'
        }],
        education: [{
          required: true,
          message: '学历不能为空',
          trigger: 'blur'
        }],
        advCity: [{
          required: true,
          message: '推送区域不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initCitys: function initCitys() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context.v;
              _this.citys = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getEnumValue: function getEnumValue(enums, value) {
      for (var index in enums) {
        var item = enums[index];
        if (value === item.values) {
          return item.keys;
        }
      }
      return '';
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.marriages = res.body;
              _this2.marriages.push({
                keys: '不限',
                values: 'all'
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getEducationsEnumList: function getEducationsEnumList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'mbmber_education_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this3.educations = res.body;
              _this3.educations.push({
                keys: '不限',
                values: '-1'
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getMemberAgeEnumList: function getMemberAgeEnumList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res, data, index, item, values, min, max, datas, i;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: 'member_age_select'
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              data = res.body;
              for (index in data) {
                item = data[index];
                values = item.values.split('-');
                min = values[0];
                max = values[1];
                datas = [];
                for (i = parseInt(min); i <= parseInt(max); i++) {
                  datas.push(i);
                }
                if (item.keys === 'max') {
                  _this4.maxAges = datas;
                } else {
                  _this4.minAges = datas;
                }
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getSexEnumList: function getSexEnumList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: 'member_sex'
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              _this5.sex = res.body;
              _this5.sex.push({
                keys: '不限',
                values: 'all'
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.fileList.push(file);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    getPushMessagePeopleGroupEnums: function getPushMessagePeopleGroupEnums() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'push_message_people_group'
              });
            case 1:
              res = _context6.v;
              _this6.pushMessagePeopleGrous = res.body;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getPushMessagePushTypeEnums: function getPushMessagePushTypeEnums() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'push_message_type'
              });
            case 1:
              res = _context7.v;
              _this7.pushMessagePushTypeEnums = res.body;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var par, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              par = {
                name: name
              };
              _context8.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context8.v;
              _this8.enumList = res.body;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.advId = null;
      this.form.message = null;
      this.form.images = null;
      this.form.peopleGroup = null;
      this.form.pushType = null;
      this.form.browseNum = null;
      this.form.commentNum = null;
      this.form.fabulousNum = null;
      this.form.operatorUserId = null;
      this.form.pushTime = null;
      this.form.messageType = null;
      this.form.messageUserId = null;
      this.form.sex = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.advId = data.advId + '';
      this.form.message = data.message;
      this.form.images = data.images;
      this.form.peopleGroup = data.peopleGroup;
      this.form.pushType = data.pushType;
      this.form.browseNum = data.browseNum + '';
      this.form.commentNum = data.commentNum + '';
      this.form.fabulousNum = data.fabulousNum + '';
      this.form.operatorUserId = data.operatorUserId + '';
      this.form.pushTime = data.pushTime + '';
      this.form.messageType = data.messageType + '';
      this.form.messageUserId = data.messageUserId + '';
    },
    updateApi: function updateApi() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return api.UPDATE_PUSHADVERTISEMENT(_this9.form);
            case 1:
              _this9.$emit('initTableData');
              _this9.$message.success('操作成功');
              _this9.handleClose();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    saveApi: function saveApi() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return api.SAVE_PUSHADVERTISEMENT(_this0.form);
            case 1:
              _this0.$emit('initTableData');
              _this0.$message.success('操作成功');
              _this0.handleClose();
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    save: function save() {
      var _this1 = this;
      if (this.fileList.length > 0) {
        var files = [];
        this.fileList.forEach(function (file) {
          files.push(file.response.body);
        });
        this.form.images = JSON.stringify(files);
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this1.form.advId != null) {
            _this1.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this1.updateApi();
            }).catch(function () {
              _this1.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this1.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  },
  created: function created() {
    this.getMarriagesEnumList();
    this.getEducationsEnumList();
    this.getMemberAgeEnumList();
    this.getSexEnumList();
    this.getPushMessagePushTypeEnums();
    this.getPushMessagePeopleGroupEnums();
    this.initCitys();
  }
};